// extracted by mini-css-extract-plugin
export default {"form":"LoginForm_form__dgoCE","perdeu":"LoginForm_perdeu__9clZl","cadastro":"LoginForm_cadastro__zW1lZ","subtitle":"LoginForm_subtitle__F4ulF"};